import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ContentService } from '../../../services/content.service';
import { ModalService } from '../../../services/modal.service';
import { SustainabilityItem } from '../../../interfaces/sustainability-item';

@Component({
  selector: 'app-product-sustainable-item',
  templateUrl: './product-sustainable-item.component.html',
  styleUrls: ['./product-sustainable-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductSustainableItemComponent implements OnInit {
  private _sustainableItem: SustainabilityItem;

  @Input() sustainableType: number;
  @Input() showBorder = false;

  constructor(
    private contentService: ContentService,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {}

  showDescription() {
    this.modalService.showSustainableInfoModal(this.label, this.description);
  }

  get description(): string {
    return this.sustainableItem?.description || '';
  }

  get icon(): string {
    return this.sustainableItem?.image || '';
  }

  get label(): string {
    return this.sustainableItem?.name || '';
  }

  get sustainableItem(): SustainabilityItem {
    if (!this.sustainableType) {
      return null;
    }

    if (!this._sustainableItem) {
      this._sustainableItem = this.contentService.sustainabilityItems.find(
        (item) => item.external_id === this.sustainableType
      );
    }

    return this._sustainableItem;
  }
}
